import { LocalNotifications } from '@capacitor/local-notifications';
import { api } from '@/lib/api';

let syncQueue = Promise.resolve();
export function syncMvpReminders(userId, isCurrent = () => true) {
  syncQueue = syncQueue.catch(() => {}).then(() => isCurrent() && updateReminders(userId, isCurrent));
  return syncQueue;
}

async function updateReminders(userId, isCurrent) {
  const { notifications: pending } = await LocalNotifications.getPending();
  const ours = pending.filter(n => n.extra?.type === 'match_mvp');
  if (!userId) {
    if (ours.length) await LocalNotifications.cancel({ notifications: ours });
    return;
  }
  const permission = await LocalNotifications.checkPermissions();
  if (permission.display !== 'granted') return;
  const { data } = await api.get('/notifications/mvp-schedule');
  if (!isCurrent()) return;
  const wanted = data.map((m, i) => ({
    id: 500000 + i,
    title: 'Vota l’MVP',
    body: `${m.title}: la partita è finita. Scegli il migliore in campo!`,
    schedule: { at: new Date(m.at), allowWhileIdle: true },
    extra: { type: 'match_mvp', userId, path: `/matches/${m.match_id}#mvp`, at: m.at },
  }));
  const same = (a, b) => a.id === b.id && a.body === b.body && a.extra?.userId === b.extra?.userId && a.extra?.path === b.extra?.path && a.extra?.at === b.extra?.at;
  const stale = ours.filter(n => !wanted.some(w => same(n, w)));
  if (stale.length) await LocalNotifications.cancel({ notifications: stale });
  if (!isCurrent()) return;
  const changed = wanted.filter(w => !ours.some(n => same(n, w)) && w.schedule.at > new Date());
  if (changed.length) await LocalNotifications.schedule({ notifications: changed });
}
